export default "__VITE_ASSET__D5CM7K7H__"